import { PaymentProviderCapability } from '@app/domain/PaymentsAccount'

export type PaymentGateway = 'stripe' | 'breathepay' | 'ryftpay' | 'dojo' | 'tablesense-test' | 'teya';

export class ApplePayWebDomainDTO {
    constructor(
        public id: string,
        public domain: string
    ) { }
}

export class PaymentsAccountDTO {
    constructor(
        public id: string,
        public currencyCode: string,
        public depositApplicationFeePercent: number,
        public cancellationChargeApplicationFeePercent: number,
        public voucherApplicationFeePercent: number,
        public processingFeePercent: number | null,
        public processingFeeUnitAmount: number | null,
        public gateway: PaymentGateway,
        public apiKey: string | null,
        public applePayWebDomains: ApplePayWebDomainDTO[] = [],
        public applePayEnabled: boolean = false,
        public active: boolean = true,
        public dateDisconnected: string | null = null,
        public capabilities?: PaymentProviderCapability[],
        public orderApplicationFeePercent: number = depositApplicationFeePercent
    ) { }
}
